import Vue from 'vue'
import http from '@/http'

export default {
  namespaced: true,

  state: () => ({
    deals: [],
    details: {},
    isLoading: false
  }),

  mutations: {
    updateDealsList(state, deals) {
      state.deals = deals
    },

    addDealDetails(state, { id, data }) {
      Vue.set(state.details, [id], data)
    },

    loading(state, status) {
      state.isLoading = status
    }
  },

  getters: {
    dealById: state => id => {
      return state.details[id]
    },

    // TODO:
    isLoading(state) {
      return state.isLoading
    }
  },

  actions: {
    async fetchDealsList({ commit }) {
      try {
        commit('loading', true)
        commit('updateDealsList', (await http.get('/profile/deals')).data)
      } finally {
        commit('loading', false)
      }
    },

    async fetchDealDetails({ commit }, { id, is_share }) {
      try {
        commit('loading', true)
        commit('addDealDetails', {
          id,
          data: (await http.get(
            `/profile/${is_share == true ? 'dealsshare' : 'deals'}/${id}`
          )).data
        })
      } finally {
        commit('loading', false)
      }
    }
  }
}
